import { v4 } from 'uuid';

export type UUID = ReturnType<typeof v4>;

export enum Resource {
  WORKSPACE = 'workspace',
  WORKFLOW = 'flow',
  SECRET = 'secret',
  BUCKET = 'bucket',
  ROLES = 'roles',
  ADMIN = 'admin',
  EXECUTE = 'execute',
}

export enum Action {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
}

export interface ResourcePermission {
  id: UUID;
  resource_type: (typeof Resource)[keyof typeof Resource];
  action: Action;
  description: string;
  enabled?: boolean;
}

type TelnyxUserType = 'organization_owner' | 'organization_sub_user';
type TelnyxUserStatus = 'enabled' | 'disabled';

export interface TelnyxOrganizationUser {
  id: UUID;
  record_type: TelnyxUserType;
  email: string;
  user_status: TelnyxUserStatus;
  created_at: string;
  last_sign_in_at: string;
}

export interface WorkspaceUser extends TelnyxOrganizationUser {
  role_name: string;
  role_id: UUID;
  creator: string;
  resource_permissions: ResourcePermission[];
}

/* -- Node Executions -- */

export enum NodeStatus {
  Pending = 'pending',
  Processing = 'processing',
  Failed = 'failed',
  Completed = 'completed',
}

export type ExecutionData = {
  run_id: string;
  user_id: string;
  org_id: string;
  service_id: string;
  flow_id: string;
  output: string;
  error: string;
  error_code: string;
  status: NodeStatus;
  name: string;
  duration: number;
  platform: string;
  email: string;
  executed_nodes: number;
  total_nodes: number;
  created_at: string;
};
